<div class="row row--secondary">
  <div class="col-12 mt-4 mb-4 d-flex align-items-center justify-content-center">
    @if (verifyIsSessionAuthorized) {
      <div class="icon icon-18" [class.haken]="sessionAuthorized" [class.cross]="!sessionAuthorized"></div>
    }
    <div class="margin-left-10 font-bold">
      @if (verifyIsSessionAuthorized && !sessionAuthorized) {
        Session noch nicht freigegeben
      }
      @if (verifyIsSessionAuthorized && sessionAuthorized) {
        Session freigegeben
      }
    </div>
  </div>
</div>

@if (dataToAuthorize && ((verifyIsSessionAuthorized && !sessionAuthorized) || !verifyIsSessionAuthorized)) {
  <div class="row">
    <div class="col-12 mb-4" [zeroLoadingIndicator]="ongoingRequest">
      <login-oauth-components-transaction-auth [payload]="dataToAuthorize" (transactionResult)="authorizedTransactionResult($event)" />
    </div>
  </div>
}

@if (userAbortedAuth) {
  <div class="row flex-column align-items-center mt-2">
    <div class="col-12">
      <p>Die Sessionfreigabe wurde abgebrochen.</p>
      <web-design-system-button size="small" (click)="restartAuth()">Freigabe erneut starten</web-design-system-button>
    </div>
  </div>
}

@if (errors.length) {
  <div class="row padding-top-15">
    <div class="col-12 text-color-error">
      @for (err of errors; track $index) {
        <p>{{ err }}</p>
      }
    </div>
  </div>
}
